namespace Q {
    export interface CommonDialogOptions extends JQueryUI.DialogOptions {
        onOpen?: () => void;
        onClose?: () => void;
        htmlEncode?: boolean;
        dialogClass?: string;
        title?: string;
    }

    export interface AlertOptions extends CommonDialogOptions {
        okButton?: string;
    }

    export function alert(message: string, options?: AlertOptions) {
        let dialog: JQuery;
        options = <Q.AlertOptions>$.extend({
            htmlEncode: true,
            okButton: text("Dialogs.OkButton"),
            title: text("Dialogs.AlertTitle"),
            onClose: null,
            onOpen: null,
            autoOpen: false,
            dialogClass: "s-MessageDialog s-AlertDialog",
            modal: true,
            width: "40%",
            maxWidth: "450",
            minWidth: "180",
            resizable: false,
            open: function () {
                if (options.onOpen) {
                    options.onOpen.call(this);
                }
            },
            close: function () {
                dialog.dialog("destroy");

                if (options.onClose) {
                    options.onClose();
                }
            },
        }, options);

        if (options.htmlEncode) {
            message = htmlEncode(message);
        }

        if (!options.buttons) {
            let buttons: any[] = [];
            buttons.push({
                text: options.okButton,
                click: function () {
                    dialog.dialog("close");
                },
            });
            options.buttons = buttons;
        }

        dialog = $('<div><div class="message" /></div>')
            .dialog(options)
            .children(".message")
            .html(message)
            .parent()
            .dialog("open");
    }

    export interface ConfirmOptions extends CommonDialogOptions {
        yesButton?: string;
        noButton?: string;
        cancelButton?: string;
        onCancel?: () => void;
        onNo?: () => void;
    }

    export function confirm(message: string, onYes: () => void, options?: ConfirmOptions): void {
        let dialog: JQuery;
        options = $.extend({
            htmlEncode: true,
            yesButton: text("Dialogs.YesButton"),
            noButton: text("Dialogs.NoButton"),
            title: text("Dialogs.ConfirmationTitle"),
            onNo: null,
            onCancel: null,
            onClose: null,
            autoOpen: false,
            modal: true,
            dialogClass: "s-MessageDialog s-ConfirmDialog",
            width: "40%",
            maxWidth: "450",
            minWidth: "180",
            resizable: false,
            open: function () {
                if (options.onOpen) {
                    options.onOpen.call(this);
                }
            },
            close: function () {
                dialog.dialog("destroy");

                if (!clicked && options.onCancel) {
                    options.onCancel();
                }
            },
            overlay: {
                opacity: 0.77,
                background: "black",
            },
        }, options);

        if (options.htmlEncode) {
            message = htmlEncode(message);
        }

        let clicked = false;

        if (!options.buttons) {
            let buttons: any[] = [];
            buttons.push({
                text: options.yesButton,
                click: function () {
                    clicked = true;
                    dialog.dialog("close");

                    if (onYes) {
                        onYes();
                    }
                },
            });

            if (options.noButton) {
                buttons.push({
                    text: options.noButton,
                    click: function () {
                        clicked = true;
                        dialog.dialog("close");

                        if (options.onNo) {
                            options.onNo();
                        } else if (options.onCancel) {
                            options.onCancel();
                        }
                    }
                });
            }

            options.buttons = buttons;
        }

        dialog = $('<div><div class="message" /></div>')
            .dialog(options)
            .children(".message")
            .html(message)
            .parent()
            .dialog("open");
    }

    export interface IFrameDialogOptions {
        html?: string;
        src?: string;
        dialogTitleKey?: string;
        autoOpen?: boolean;
        autoDestroy?: boolean;
    }

    export function iframeDialog(options: IFrameDialogOptions): JQuery {
        let doc: any,
            $element: JQuery = $('<div style="overflow: hidden;"><iframe /></div>');
        let settings: IFrameDialogOptions = $.extend(<JQueryUI.DialogOptions>{
            autoOpen: (options.autoOpen != null) ? options.autoOpen : true,
            width: "60%",
            height: "400",
            modal: true,
            title: text(options.dialogTitleKey || "Dialogs.AlertTitle"),
            open: function () {
                const iframe = <HTMLIFrameElement>($element.find("iframe").css({
                    border: "none",
                    width: "100%",
                    height: "100%",
                })[0]);

                if (settings.src) {
                    iframe.src = settings.src;

                    return;
                }

                doc = (iframe).contentDocument;
                doc.open();
                doc.write(settings.html);
                doc.close();
            },
            close: function () {
                if (!settings.src) {
                    doc.open();
                    doc.write("");
                    doc.close();
                }

                if (options.autoDestroy) {
                    $element.dialog("destroy").html("");
                }
            },
        }, options);
        $element.dialog(settings as any);

        return $element;
    }

    export function information(message: string, onOk: () => void, options?: Q.ConfirmOptions) {
        confirm(message, onOk, $.extend<Q.ConfirmOptions>({
            title: text("Dialogs.InformationTitle"),
            dialogClass: "s-MessageDialog s-InformationDialog",
            yesButton: text("Dialogs.OkButton"),
            noButton: null,
        }, options));
    }

    export function warning(message: string, options?: Q.AlertOptions) {
        alert(message, $.extend<Q.AlertOptions>({
            title: text("Dialogs.WarningTitle"),
            dialogClass: "s-MessageDialog s-WarningDialog",
        }, options));
    }
}
